export const tags = ref<string[]>([])
export const mentions = ref<any[]>([])
export const invitations = ref<any[]>([])

export const input = ref<string>('')

export function useMediaTaggingState() {

  const invitationsUpdate = (newInvitations: any[]) : boolean => {
    if (newInvitations.length === 0) return false
    invitations.value = newInvitations
    return true
  }

  const invitationAdd = (invitation: any) : boolean => {
    if (invitations.value.some(i => i.id === invitation.id)) return false
    invitations.value.push(invitation)
    return true
  }

  const invitationRemove = (invite: any) : boolean => {
    if (!invitations.value.some(item => item.id === invite.id)) return false
    invitations.value = invitations.value.filter(item => item.id !== invite.id)
    return true
  }

  const mentionsUpdate = (newMentions: any[]) : boolean => {
    if (newMentions.length === 0) return false
    mentions.value = newMentions.map(m => ({
      username: m.username,
      displayName: m.displayName,
      avatarUrl: m.avatarUrl,
      id: m.id
    }))
    return true
  }

  const mentionAdd = (user: any) : boolean => {
    if (mentions.value.some(m => m.username === user.username)) return false
    mentions.value.unshift({
      username: user.username,
      displayName: user.displayName,
      avatarUrl: user.avatarUrl,
    })
    return true
  }

  const mentionRemove = (user: any) : boolean => {
    if (!mentions.value.some(m => m.username === user.username)) return false
    mentions.value = mentions.value.filter(m => m.username !== user.username)
    return true
  }

  const tagsUpdate = (newTags: string[]) : boolean => {
    if (newTags.length === 0) return false
    tags.value = newTags.map(tag => tag.trim())
    return true
  }

  const tagAdd = (tag: string) : boolean => {
    const trimmed = tag.trim()
    if (tags.value.includes(trimmed)) return false
    tags.value.push(trimmed)
    return true
  }

  const tagRemove = (tag: string) : boolean => {
    const trimmed = tag.trim()
    if (!tags.value.includes(trimmed)) return false
    tags.value = tags.value.filter(t => t !== tag)
    return true
  }

  const resetState = () => {
    tags.value = []
    mentions.value = []
    input.value = ''
  }

  return {
    tags,
    invitations,
    mentions,
    input,
    invitationAdd,
    invitationRemove,
    invitationsUpdate,
    mentionsUpdate,
    mentionAdd,
    mentionRemove,
    tagAdd,
    tagRemove,
    tagsUpdate,
    resetState
  }
}
